"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype);
    return g.next = verb(0), g["throw"] = verb(1), g["return"] = verb(2), typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.LeadForm = void 0;
var input_output_helper_const_1 = require("@const/input-output-helper.const");
var input_mapping_const_1 = require("@const/input.mapping.const");
var lead_service_1 = require("@services/lead.service");
var object_service_1 = require("@services/object-service");
var settings_service_1 = require("@services/settings.service");
var api_wrapper_1 = require("@src/api/api-wrapper");
var generator_const_1 = require("@src/const/dom-crud/generator.const");
var error_helper_const_1 = require("@src/const/error-handling/error-helper.const");
var helper_const_1 = require("@src/const/helper.const");
var input_output_module_const_1 = require("@src/const/input-output-module.const");
var notes_helper_const_1 = require("@src/const/notes-helper.const");
var validate_dynamic_checkboxes_1 = require("@src/modules/shared/validation/validate-dynamic-checkboxes");
var inter_communication_service_1 = require("@src/services/inter-communication.service");
var translation_1 = __importDefault(require("@src/services/translation"));
var cash_dom_1 = __importDefault(require("cash-dom"));
var element_generator_1 = require("../../../element-generator");
var send_email_service_1 = require("../membership-completion/services/send-email.service");
var yond_finish_service_1 = require("../membership-completion/services/yond-finish.service");
var mappings_const_1 = require("./mappings.const");
var tracker_service_1 = require("@src/services/tracker.service");
var LeadForm = /** @class */ (function () {
    function LeadForm() {
        this.config = object_service_1.ObjectService.getInstance(settings_service_1.SettingsService);
        this.elementGenerator = object_service_1.ObjectService.getInstance(element_generator_1.ElementGenerator);
        this.sendEmailService = object_service_1.ObjectService.getInstance(send_email_service_1.SendEmailService);
        this.leadService = object_service_1.ObjectService.getInstance(lead_service_1.LeadService);
        this.yondFinishService = object_service_1.ObjectService.getInstance(yond_finish_service_1.YondFinishService);
        this.communicationService = object_service_1.ObjectService.getInstance(inter_communication_service_1.InterCommunicationService);
        this.trackerService = object_service_1.ObjectService.getInstance(tracker_service_1.TrackerService);
        this.validBirthdayModule = false;
    }
    LeadForm.prototype.loadModule = function () {
        return __awaiter(this, void 0, void 0, function () {
            var submitButton;
            var _this = this;
            var _a, _b, _c, _d;
            return __generator(this, function (_e) {
                this.prepareEmployeeView();
                this.preparePhoneField();
                this.elementGenerator.createElements();
                (0, notes_helper_const_1.addConfigNotes)((_b = (_a = this.config.get) === null || _a === void 0 ? void 0 : _a.leadForm) === null || _b === void 0 ? void 0 : _b.notes);
                (0, input_output_helper_const_1._PrefillFields)(this.$container);
                window.addEventListener('beforeunload', function () {
                    //navigator.sendBeacon(_GetCloudFunctionUrl("fms") + "/lead/create-hubspot", JSON.stringify({ reason: 'left-before-next-step' }));
                });
                submitButton = (0, cash_dom_1.default)(mappings_const_1._LeadFormButtons.submitButton.id);
                //Submit the form
                if (submitButton === null || submitButton === void 0 ? void 0 : submitButton.length) {
                    console.log('Bound lead submit button', submitButton);
                    submitButton.on('click', function () { return __awaiter(_this, void 0, void 0, function () {
                        return __generator(this, function (_a) {
                            switch (_a.label) {
                                case 0:
                                    console.log('Lead form submission');
                                    return [4 /*yield*/, this.sendForm()];
                                case 1:
                                    _a.sent();
                                    return [2 /*return*/];
                            }
                        });
                    }); });
                    // validate form on enter key
                    this.leadFormElement = submitButton.closest('form');
                    (0, input_output_helper_const_1._OverwriteIndirectFormSubmit)(this.leadFormElement, function () { return __awaiter(_this, void 0, void 0, function () {
                        return __generator(this, function (_a) {
                            switch (_a.label) {
                                case 0:
                                    console.log('Lead form indirect submission');
                                    return [4 /*yield*/, this.sendForm()];
                                case 1:
                                    _a.sent();
                                    return [2 /*return*/];
                            }
                        });
                    }); });
                }
                else {
                    console.warn('No lead submit button found with id', mappings_const_1._LeadFormButtons.submitButton.id);
                }
                // yond get data
                if (((_d = (_c = this.config) === null || _c === void 0 ? void 0 : _c.get) === null || _d === void 0 ? void 0 : _d.technologyType) === 'yond') {
                    this.yondFinishService.handleYondFinish(this.$container, true);
                }
                // optional birthday module in lead step
                this.communicationService.subscribeChildren(this).subscribe(function (event) {
                    if (event.event === 'validation' && event.module.moduleKey === 'birthday') {
                        _this.validBirthdayModule = event.value.valid;
                        if (event.value.valid) {
                            console.log('Birthday Module event received', event.value.valid);
                            (0, input_output_helper_const_1._SaveFieldInLocalstorage)(input_mapping_const_1._BirthdayForm.age, event.value.data.age);
                            (0, input_output_helper_const_1._SaveFieldInLocalstorage)(input_mapping_const_1._BirthdayForm.dateOfBirth, event.value.data.birthday);
                        }
                        else {
                            (0, input_output_helper_const_1._RemoveFieldFromLocalstorage)(input_mapping_const_1._BirthdayForm.age);
                            (0, input_output_helper_const_1._RemoveFieldFromLocalstorage)(input_mapping_const_1._BirthdayForm.dateOfBirth);
                        }
                    }
                });
                return [2 /*return*/];
            });
        });
    };
    LeadForm.prototype.prepareEmployeeView = function () {
        var _a;
        if ((_a = this.config.get) === null || _a === void 0 ? void 0 : _a.employeeVersion) {
            (0, cash_dom_1.default)('[data-employee="true"]').css('display', 'flex');
        }
    };
    LeadForm.prototype.gatherData = function () {
        var lead = {};
        var valid = true;
        for (var key in input_mapping_const_1._LeadMapping) {
            var result = (0, input_output_helper_const_1._ReadFieldValue)(input_mapping_const_1._LeadMapping[key]);
            var validation = (0, input_output_helper_const_1._ValidateAnyField)(this.$container, input_mapping_const_1._LeadMapping[key]);
            if (!validation.valid) {
                valid = false;
            }
            //console.log("Got lead data", result, "for key", key)
            if (result) {
                if (input_mapping_const_1._LeadMapping[key].uid) {
                    localStorage.setItem(input_mapping_const_1._LeadMapping[key].uid, result.trim());
                }
                if (key !== 'checkbox') {
                    lead[key] = result.trim();
                }
            }
            if (key === 'newsletterOptIn' &&
                this.$container.find("[data-get=\"".concat(input_mapping_const_1._LeadMapping.newsletterOptIn.uid, "\"]")).length) {
                lead.newsletterOptIn = Boolean(result);
            }
        }
        // additionally validate a studio dropdown if set
        if (this.$container.find("[data-get=\"".concat(input_mapping_const_1._DefaultMapping.studioId.uid, "\"]")).length) {
            var result = localStorage.getItem(input_mapping_const_1._DefaultMapping.studioId.uid);
            if (!result) {
                console.error('A data-get=', input_mapping_const_1._DefaultMapping.studioId.uid, 'exists, but isnt set in local storage');
                // valid = false;
            }
        }
        // check consents for privacy
        lead.privacyConfiguration = (0, validate_dynamic_checkboxes_1.getConsentCheckboxValues)(this.$container);
        return valid ? lead : undefined;
    };
    LeadForm.prototype.sendForm = function () {
        return __awaiter(this, void 0, void 0, function () {
            var lead, isValid, otherFieldsValid, leadhash, oldLeadHash, e_1, _a, e_2;
            var _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m, _o, _p, _q, _r, _s, _t, _u, _v, _w, _x;
            return __generator(this, function (_y) {
                switch (_y.label) {
                    case 0:
                        (0, generator_const_1._HideErrorMessage)();
                        //if settings object injects the phoneprefix or by default +49
                        this.preparePhoneField();
                        lead = this.gatherData();
                        console.log('Preparing lead with data', lead);
                        isValid = true;
                        if (lead === undefined) {
                            isValid = false;
                        }
                        // validate birthday module if its inside leadform
                        if (!this.validBirthdayModule && this.$container.find("[data-module='birthday']").length > 0) {
                            (0, generator_const_1._ShowErrorMessage)(translation_1.default.t('noValidBirthday'));
                            isValid = false;
                        }
                        if (!((_b = lead.firstname) === null || _b === void 0 ? void 0 : _b.length)) {
                            (0, generator_const_1._ShowErrorMessage)(translation_1.default.t('noValidFirstname'));
                            isValid = false;
                        }
                        if (!((_c = lead.lastname) === null || _c === void 0 ? void 0 : _c.length)) {
                            (0, generator_const_1._ShowErrorMessage)(translation_1.default.t('noValidLastname'));
                            isValid = false;
                        }
                        if (!(0, validate_dynamic_checkboxes_1.validateDynamicCheckboxes)(this.$container)) {
                            isValid = false; // the function already shows the errors
                        }
                        otherFieldsValid = (0, input_output_module_const_1.ValidateFieldsInModule)(this, {
                            showErrors: true,
                            animateToFirstError: true,
                            mappings: input_mapping_const_1._CustomerMapping,
                        }, true);
                        console.log('other field res', otherFieldsValid);
                        if (!otherFieldsValid.valid)
                            isValid = false;
                        if (!isValid)
                            return [2 /*return*/];
                        //hash is to determine if user has changed sth (new lead)
                        lead.studioId = +(0, input_output_helper_const_1._ReadFieldValue)(input_mapping_const_1._AllMappings.studioId);
                        lead.phone = localStorage.getItem('phonePrefix') + localStorage.getItem(input_mapping_const_1._LeadMapping.telephone_mobile.uid);
                        leadhash = (0, helper_const_1._GenerateHash)(JSON.stringify(lead));
                        oldLeadHash = localStorage.getItem('leadhash');
                        // add lead notes if any
                        lead.notes = (0, notes_helper_const_1.getLocalStorageNotesString)();
                        if (!(leadhash !== oldLeadHash)) return [3 /*break*/, 14];
                        (0, generator_const_1._CreateLoadingScreen)();
                        if (!!((_e = (_d = this.config.get) === null || _d === void 0 ? void 0 : _d.leadForm) === null || _e === void 0 ? void 0 : _e.skipLeadCreation)) return [3 /*break*/, 7];
                        if (!(0, api_wrapper_1.useUnified)(this.config, 'leadCreation')) return [3 /*break*/, 5];
                        _y.label = 1;
                    case 1:
                        _y.trys.push([1, 3, , 4]);
                        return [4 /*yield*/, this.leadService.createFirestoreLead(leadhash, lead)];
                    case 2:
                        _y.sent(); // waiting for rework of connector
                        return [3 /*break*/, 4];
                    case 3:
                        e_1 = _y.sent();
                        console.error('failed lead creation', e_1);
                        (0, generator_const_1._ShowErrorMessage)((_f = e_1 === null || e_1 === void 0 ? void 0 : e_1.displayError) !== null && _f !== void 0 ? _f : 'Form transfer failed');
                        (0, generator_const_1._DeleteLoadingScreen)();
                        return [2 /*return*/, false];
                    case 4: return [3 /*break*/, 7];
                    case 5: return [4 /*yield*/, this.leadService.createTechnologyTypeLead(lead)];
                    case 6:
                        _y.sent();
                        _y.label = 7;
                    case 7:
                        localStorage.setItem('leadhash', String(leadhash));
                        if (!((_h = (_g = this.config.get) === null || _g === void 0 ? void 0 : _g.receiverMail) === null || _h === void 0 ? void 0 : _h.sendLeadEmail)) return [3 /*break*/, 11];
                        _y.label = 8;
                    case 8:
                        _y.trys.push([8, 10, , 11]);
                        return [4 /*yield*/, this.sendEmailService.sendEmail(this.config.get.receiverMail.sendLeadEmail, lead, 'Funnel lead')];
                    case 9:
                        _y.sent();
                        return [3 /*break*/, 11];
                    case 10:
                        _a = _y.sent();
                        return [3 /*break*/, 11];
                    case 11:
                        if (!(((_k = (_j = this.config.get) === null || _j === void 0 ? void 0 : _j.leadForm) === null || _k === void 0 ? void 0 : _k.manyChat) && !(0, api_wrapper_1.useUnified)(this.config, 'leadCreation'))) return [3 /*break*/, 13];
                        return [4 /*yield*/, this.leadService.createManychatLead(lead)];
                    case 12:
                        _y.sent();
                        _y.label = 13;
                    case 13:
                        // fitaso lead
                        if ((_m = (_l = this.config.get) === null || _l === void 0 ? void 0 : _l.leadForm) === null || _m === void 0 ? void 0 : _m.fitaso) {
                            this.leadService.createFitasoLead(lead, this.config);
                        }
                        (0, generator_const_1._DeleteLoadingScreen)();
                        _y.label = 14;
                    case 14:
                        //overwrite phone input field - shortly before redirecting to webflow forms
                        if ((0, cash_dom_1.default)(input_mapping_const_1._LeadMapping.telephone_mobile.uid).length) {
                            (0, cash_dom_1.default)(input_mapping_const_1._LeadMapping.telephone_mobile.uid).val(lead.phone);
                        }
                        // enable form submit
                        if (this.leadFormElement.length > 0) {
                            (0, input_output_helper_const_1._EnableFormSubmit)(this.leadFormElement);
                        }
                        // remove notes from localstorage to prevent them appearing in contract on membership completion
                        (0, notes_helper_const_1.clearLocalstorageNotes)();
                        // update hidden fields
                        (0, input_output_helper_const_1._PrefillHiddenFields)();
                        // send lead finished event
                        this.communicationService.sendEvent({
                            event: 'custom',
                            module: this,
                            name: 'leadFinished',
                            value: true,
                        });
                        _y.label = 15;
                    case 15:
                        _y.trys.push([15, 17, , 18]);
                        return [4 /*yield*/, this.trackerService.trackFunnelEvent(this.config, 'leadFinished')];
                    case 16:
                        _y.sent();
                        return [3 /*break*/, 18];
                    case 17:
                        e_2 = _y.sent();
                        console.error('leadFinished tracking failed', e_2);
                        return [3 /*break*/, 18];
                    case 18:
                        //Next button we done here
                        if (!((_q = (_p = (_o = this.config) === null || _o === void 0 ? void 0 : _o.get) === null || _p === void 0 ? void 0 : _p.leadForm) === null || _q === void 0 ? void 0 : _q.skipFormSubmission)) {
                            (_s = (_r = (0, cash_dom_1.default)(mappings_const_1._LeadFormButtons.webflowSubmitButton.id)) === null || _r === void 0 ? void 0 : _r.get(0)) === null || _s === void 0 ? void 0 : _s.click();
                        }
                        if ((_t = this.config.get) === null || _t === void 0 ? void 0 : _t.redirect) {
                            window.location.href = this.config.get.redirect;
                        }
                        else if ((_v = (_u = this.config.get) === null || _u === void 0 ? void 0 : _u.leadForm) === null || _v === void 0 ? void 0 : _v.successMessage) {
                            (0, error_helper_const_1._ShowSuccessMessage)((_x = (_w = this.config.get) === null || _w === void 0 ? void 0 : _w.leadForm) === null || _x === void 0 ? void 0 : _x.successMessage);
                        }
                        return [2 /*return*/, true];
                }
            });
        });
    };
    // This should be unnecessary now, the dropdown preseselects based on data-get or button text
    // it is still used as fallback in case no matching data-set and no matching button text was used
    LeadForm.prototype.preparePhoneField = function () {
        var _a, _b;
        // either use from settings object, localstorage (dropdown) or default to +49
        var phonePrefix = ((_b = (_a = this.config.get) === null || _a === void 0 ? void 0 : _a.leadForm) === null || _b === void 0 ? void 0 : _b.phonePrefix) || (0, input_output_helper_const_1._ReadFieldFromLocalstorage)(input_mapping_const_1._AllMappings.phonePrefix) || '+49';
        if (!localStorage.getItem('phonePrefix')) {
            (0, input_output_helper_const_1._SaveFieldInLocalstorage)(input_mapping_const_1._CustomerMapping.phonePrefix, phonePrefix);
        }
        var phoneField = (0, cash_dom_1.default)("[data-get=\"".concat(input_mapping_const_1._LeadMapping.telephone_mobile.uid, "\"]"));
        if (phoneField.length) {
            var result = String(phoneField.val());
            //console.log("Got phone val", result, "with phone prefix", phonePrefix)
            result = result.replace(/^0+/, ''); // remove leading 0
            result = result.replace(phonePrefix, ''); // new, prevent writing phone prefix in the input field
            //console.log("removed prefix to", result)
            phoneField.val(result);
        }
        else {
            console.log('no phone field found', input_mapping_const_1._LeadMapping.telephone_mobile.uid);
        }
    };
    return LeadForm;
}());
exports.LeadForm = LeadForm;
